// extracted by mini-css-extract-plugin
export default {"main":"home_main__XWYaU","top":"home_top__FifAB","content":"home_content__ZJL66","main1":"home_main1__h--PA"};